import { render } from "./delete-dialog.vue?vue&type=template&id=2f87827d"
import script from "./delete-dialog.vue?vue&type=script&lang=js"
export * from "./delete-dialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__